<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-alert class="mb-0" text type="info" border="left">
          <p class="mb-2">
            <strong class="font-weight-bold">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msgCrossword'
              )
            }}</strong>
          </p>
          <p class="mb-2">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msgCreate1'
              )
            }}
          </p>
          <p class="mb-2">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msgCreate2'
              )
            }}
          </p>
          <p class="mb-2">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msgCreate3'
              )
            }}
          </p>
          <p class="mb-2">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msgCreate4'
              )
            }}
          </p>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <p class="title">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.sizeTables'
            )
          }}
          <span class="red--text">*</span>
        </p>
        <div>
          <v-text-field
            type="number"
            outlined
            :rules="dimensionRules"
            clearable
            class="textField"
            :placeholder="
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.insertGame.sizeTable'
              )
            "
            v-model.number="sizeInt"
            @change="sizeChange"
            min="2"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="6">
        <p class="title">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.totalScore'
            )
          }}
          <span class="red--text">*</span>
        </p>
        <v-text-field
          type="number"
          outlined
          disabled
          class="textField"
          :placeholder="
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.totalScore'
            )
          "
          v-model.number="question_score"
          readonly
          min="0"
          @change="checkMinScore"
        ></v-text-field>
      </v-col>
    </v-row>

    <template v-if="tableGame != null">
      <div>
        <div class="mb-4 title">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.insertGame.tableAnswer'
            )
          }}
        </div>
        <v-row>
          <v-col cols="12">
            <div class="puzzle-zone">
              <div v-if="showGrid" class="wordsearch_grid">
                <div
                  class="d-flex"
                  v-for="(rowV, row) in sizeIntComputed"
                  :key="`row_${row}`"
                >
                  <div
                    class="d-flex justify-center"
                    v-for="(colV, col) in sizeIntComputed"
                    :key="`${row}_${col}`"
                  >
                    <div
                      :class="letterTileClasses(col, row)"
                      :data-x="col"
                      :data-y="row"
                      class="d-flex"
                      style="position: relative"
                      @mousedown.prevent="wordSelectStart($event)"
                      @mouseup="wordSelectUpdate($event)"
                      @mousemove="wordSelectUpdate($event)"
                      @touchstart.prevent="wordSelectStart($event)"
                      @touchend="wordSelectUpdate($event)"
                      @touchmove="wordSelectUpdate($event)"
                    >
                      <svg width="100%" height="100%" viewBox="0 -1 24 24">
                        <text
                          x="50%"
                          dominant-baseline="middle"
                          y="50%"
                          text-anchor="middle"
                        >
                          {{ gridVal(col, row) }}
                        </text>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="pl-4 pt-4">
              <v-row>
                <v-col cols="8"
                  ><p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.listWord'
                      )
                    }}
                  </p></v-col
                >
                <v-col cols="4">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertGame.score'
                      )
                    }}
                  </p>
                </v-col>
              </v-row>

              <template v-if="tableGame.wordList.length > 0">
                <!-- <div class="d-flex align-center mb-4" :key="`word_header`">
                  <div class="flex-grow-1">
                    <span class="title">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.listWord'
                        )
                      }}
                    </span>
                  </div>
                  <div class="flex-shrink-1" style="width: 165px">
                    <span class="title"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.score'
                        )
                      }}
                    </span>
                  </div>
                  <div class="flex-shrink-1 pl-4" style="width: 80px">
                    <span class="title">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.delete'
                        )
                      }}
                    </span>
                  </div>
                </div> -->
                <template v-for="(word, idx) of tableGame.wordList">
                  <div class="d-flex align-center" :key="`word_${idx}`">
                    <div class="flex-grow-1">
                      <span class="subtitle-1">
                        {{ word.text }}
                      </span>
                    </div>
                    <div class="flex-shrink-1" style="width: 150px">
                      <v-text-field
                        type="number"
                        outlined
                        :rules="scoreRules"
                        clearable
                        class="textField"
                        :placeholder="
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.insertGame.score'
                          )
                        "
                        v-model.number="word.score"
                        min="0"
                        hide-details=""
                      ></v-text-field>
                    </div>
                    <div class="flex-shrink-1 pl-4" style="width: 95px">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        @click="removeWord(idx)"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </div>
                  </div>
                  <v-divider
                    class="my-3"
                    v-if="idx < tableGame.wordList.length - 1"
                    :key="`divider_word_${idx}`"
                  ></v-divider>
                </template>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col cols="4">
                    <p class="title">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.totalScore'
                        )
                      }}
                      <span
                        >{{ question_score }}
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.insertGame.score'
                          )
                        }}</span
                      >
                    </p>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-alert type="info" text>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertGame.msg2'
                    )
                  }}
                </v-alert>
              </template>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>

    <v-overlay :value="overlay" absolute>
      <div class="text-center ma-4">
        <v-card light>
          <v-card-title
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.msg3'
              )
            }}
          </v-card-title>
          <v-card-text>
            <div
              class="d-flex align-space-between justify-center"
              v-if="activeWord.length > 0"
            >
              <template v-for="(item, idx) in activeWord.length">
                <div :key="`input-each-letter-${idx}`">
                  <input
                    type="text"
                    class="letter-input"
                    v-model="activeWord[idx]"
                    maxlength="1"
                    :ref="`input_letter_${idx}`"
                    @keyup="focusNext($event, idx)"
                    @keydown.space.prevent
                    :disabled="lockActiveWord[idx]"
                  />
                </div>
                <div
                  class="px-2 title align-self-center"
                  v-if="idx < activeWord.length - 1"
                  :key="`div-each-letter-${idx}`"
                >
                  -
                </div>
              </template>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="overlay = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                )
              }}
            </v-btn>
            <v-btn
              text
              color="primary"
              :disabled="!fillAllTextBox"
              @click="setLetterInTable"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.ok'
                )
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: ['options', 'answerLength', 'gameBody'],
  data: () => ({
    showGrid: true,
    overlay: false,
    sizeInt: 10,
    randomItems: 0,
    tableGame: null,
    question: '',
    question_score: 0,
    scoreRules: [
      (v) =>
        !!v ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.scoreRules'
        ),
    ],
    questionRules: [
      (v) =>
        !!v ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.lectureStep.insertExam.insertGame.questionRules'
        ),
    ],
    selectedRange: {
      start: undefined,
      end: undefined,
    },
    foundTiles: [],
    lastDrag: null,
    activeWord: [],
    lockActiveWord: [],
    gameReady: false,
    mode: 'add',
  }),
  watch: {
    tableGame: {
      deep: true,
      handler: function (val) {
        // auto calculate score
        if (val.wordList.length > 0) {
          this.question_score = 0;
          val.wordList.forEach((word) => {
            this.question_score += word.score;
          });
        }

        this.checkReady();
      },
    },
    overlay(val) {
      if (val === false) {
        this.lastDrag = null;
      }
    },
    gameReady(val) {
      this.$emit('onGameReady', val);
    },
    sizeInt(val) {
      this.redrawGrid();
    },
  },
  computed: {
    fillAllTextBox() {
      let idx = this.activeWord.indexOf('');
      if (idx === -1) {
        return true;
      }
      return false;
    },
    sizeIntComputed() {
      return this.sizeInt;
    },
    dimensionRules() {
      return [(v) => !!v || 'กรุณากรอกขนาดตาราง n x n'];
    },
  },
  mounted() {
    // this.$emit("update:answerLength", 4);
    this.startup();
  },
  methods: {
    startup(isEdit = false) {
      // console.log(this.mode, this.tableGame);
      if (isEdit === true) {
        // setting exist data to renderer ui
        this.mode = 'edit';
        this.init();
      } else {
        // assume as add mode
        this.mode = 'add';
        this.gameReady = false;
        this.addGame(); // auto add 1 game
      }

      this.checkReady();
    },
    init() {
      // console.log(this.gameBody);
      if (this.gameBody != null) {
        // setting score
        this.gameBody.config.wordList.forEach((word, idx) => {
          word.score = this.gameBody.arrayScore[idx];
        });
        this.tableGame = this.gameBody.config;
        this.sizeInt = this.gameBody.puzzleGridSize;

        // generate usedTiles
        this.tableGame.usedTiles = [];
        for (let word of this.tableGame.wordList) {
          let positions = this.$gameUtil.gridPositions(word.data);
          // add tile used
          for (let pos of positions) {
            this.tableGame.usedTiles.push({
              x: pos.x,
              y: pos.y,
            });
          }
        }
      }
    },
    redrawGrid() {
      this.showGrid = false;
      this.$nextTick(() => {
        this.showGrid = true;
      });
    },
    checkReady() {
      // console.log("check ready");
      let dataOk = true;

      if (this.tableGame.wordList.length == 0) {
        // console.log("no word list");
        dataOk = false;
      }

      //#region check score
      for (let word of this.tableGame.wordList) {
        if (word.score == null || word.score == 0) {
          dataOk = false;
        }
      }
      //#endregion

      this.gameReady = dataOk;
    },
    addGame() {
      let gameInstance = {
        wordList: [],
        letterTable: [],
        usedTiles: [],
      };
      for (let i = 0; i < this.sizeInt; i++) {
        gameInstance.letterTable.push(new Array(this.sizeInt).fill(''));
      }
      console.log(gameInstance);
      this.tableGame = gameInstance;
    },
    clearGame(index) {
      this.tableGame = {
        wordList: [],
        letterTable: [],
        usedTiles: [],
      };
    },
    focusNext(event, idx) {
      const el = this.$refs[`input_letter_${idx + 1}`];
      if (
        el != null &&
        el[0] != undefined &&
        event.keyCode >= 65 &&
        event.keyCode <= 90
      ) {
        if (el[0].disabled) {
          this.shouldTryFocusInput(idx);
        } else {
          el[0].focus();
        }
      } else {
        if (this.fillAllTextBox == true) {
          // auto close
          this.setLetterInTable();
        } else {
          this.shouldTryFocusInput(idx);
        }
      }
    },
    shouldTryFocusInput(idx) {
      let nextIdx = idx + 1;
      if (nextIdx < this.activeWord.length) {
        this.focusNext(nextIdx);
      }
    },
    sizeChange() {
      // clear game data
      this.tableGame.wordList = [];
      this.tableGame.letterTable = [];
      this.question_score = 0;
      for (let i = 0; i < this.sizeInt; i++) {
        this.tableGame.letterTable.push(new Array(this.sizeInt).fill(''));
      }
    },
    removeWord(index) {
      // remove tile
      let wordLine = this.tableGame.wordList[index];
      let positions = this.$gameUtil.gridPositions(wordLine.data);
      // console.log(positions.entries());
      for (let i = 0; i < positions.length; i++) {
        let findUsedTile = this.tableGame.usedTiles.filter(
          (pos) => pos.x == positions[i].x && pos.y == positions[i].y
        );

        if (findUsedTile != null) {
          // check is last tile
          if (findUsedTile.length == 1) {
            this.setGridVal(positions[i].x, positions[i].y, '');
          }

          // remove used tile -1
          let usedTileAtCell = this.tableGame.usedTiles.findIndex(
            (pos) => pos.x == positions[i].x && pos.y == positions[i].y
          );
          if (usedTileAtCell !== -1) {
            this.tableGame.usedTiles.splice(usedTileAtCell, 1);
          }
        }
      }

      this.tableGame.wordList.splice(index, 1);
    },
    setLetterInTable() {
      // check all word is lock
      if (this.lockActiveWord.indexOf(false) === -1) {
        this.overlay = false;
        return;
      }

      // check duplicate word
      let word = this.activeWord.join('').toUpperCase();
      if (this.tableGame.wordList.find((x) => x.text == word) != null) {
        this.overlay = false;
        alert('Word Duplicated');
        return;
      }

      let positions = this.$gameUtil.gridPositions(this.lastDrag);
      // console.log(positions.entries());
      for (let i = 0; i < this.activeWord.length; i++) {
        this.setGridVal(positions[i].x, positions[i].y, this.activeWord[i]);

        // add tile used
        this.tableGame.usedTiles.push({
          x: positions[i].x,
          y: positions[i].y,
        });
      }

      this.tableGame.wordList.push({
        text: this.activeWord.join('').toUpperCase(),
        score: 1,
        data: this.lastDrag,
      });
      // console.log(this.tableGame);
      this.overlay = false;
    },
    showGridValueDialog() {
      this.activeWord = [];
      this.lockActiveWord = [];

      let positions = this.$gameUtil.gridPositions(this.lastDrag);
      for (let pos of positions) {
        let val = this.gridVal(pos.x, pos.y);
        this.activeWord.push(val);
        if (val != '' && val != null) {
          this.lockActiveWord.push(true);
        } else {
          this.lockActiveWord.push(false);
        }
      }

      this.overlay = true;
      this.$nextTick(() => {
        this.focusNext(-1);
      });
    },
    getGameBody() {
      let arrScore = this.tableGame.wordList.map((x) => x.score);
      return {
        config: this.tableGame,
        puzzleGridSize: this.sizeInt,
        arrayScore: arrScore,
      };
    },
    checkMinScore() {
      if (this.question_score < 0) this.question_score = 0;
    },
    //#region grid methods
    setGridVal(x, y, val) {
      // console.log(gameIdx, x, y, val);
      if (typeof this.tableGame.letterTable[y] !== 'undefined') {
        if (typeof this.tableGame.letterTable[y][x] !== 'undefined') {
          this.tableGame.letterTable[y][x] = val.toUpperCase();
        }
      }
    },
    gridVal(x, y) {
      if (this.tableGame.letterTable == null) {
        return '';
      }

      if (typeof this.tableGame.letterTable[y] !== 'undefined') {
        if (typeof this.tableGame.letterTable[y][x] !== 'undefined') {
          return this.tableGame.letterTable[y][x].toUpperCase();
        }
      }
      return '';
    },
    letterTileClasses(x, y) {
      const classes = ['letter-tile'];
      if (this.isTileHighlighted(x, y)) {
        classes.push('letter-tile-highlighted');
      }
      let val = this.gridVal(x, y);
      if (val != '') {
        classes.push('letter-tile-hasText');
      }
      return classes;
    },
    isTileAFoundWordTile(x, y) {
      for (let i = 0; i < this.foundTiles.length; i += 1) {
        if (this.foundTiles[i].x === x && this.foundTiles[i].y === y) {
          return true;
        }
      }
      return false;
    },
    isTileHighlighted(x, y) {
      if (this.selectedRange.start && this.selectedRange.end) {
        const r = this.selectedRange;
        const minX = Math.min(r.start.x, r.end.x);
        const maxX = Math.max(r.start.x, r.end.x);
        const minY = Math.min(r.start.y, r.end.y);
        const maxY = Math.max(r.start.y, r.end.y);
        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
          // in range. If X or Y are equal then it's a straight line, otherwise
          // Work out diagonal logic.
          return r.start.x === r.end.x || r.start.y === r.end.y;
        }
      }
      return false;
    },
    wordSelectStart(event) {
      const touchedElement = event.target.closest('div.letter-tile');
      if (
        touchedElement &&
        touchedElement.dataset &&
        touchedElement.dataset.x
      ) {
        this.selectedRange.start = {
          x: parseInt(touchedElement.dataset.x, 10),
          y: parseInt(touchedElement.dataset.y, 10),
        };
        return true;
      }
      return false;
    },
    wordSelectUpdate(event) {
      // We never started selecting, bail early.
      if (this.selectedRange.start === undefined) {
        return false;
      }
      let touch = event;
      if (event.type.indexOf('touch') === 0) {
        touch = event.changedTouches.item(0);
      }
      const tEl = document.elementFromPoint(touch.clientX, touch.clientY);
      if (!tEl) {
        return false;
      }
      const touchedElement = tEl.closest('div.letter-tile');
      if (
        touchedElement &&
        touchedElement.dataset &&
        touchedElement.dataset.x
      ) {
        const x = parseInt(touchedElement.dataset.x, 10);
        const y = parseInt(touchedElement.dataset.y, 10);
        const dx = Math.abs(x - this.selectedRange.start.x);
        const dy = Math.abs(y - this.selectedRange.start.y);
        // Verify the end is valid.
        // If dy (change in y) or dx (change in x) is zero, then it is horizontal/vertcal == OK.
        // Or if dx === dy, then it is diagonal.
        if ((dy === 0 && dx > 0) || (dx === 0 && dy > 0) || dx === dy) {
          this.selectedRange.end = { x, y };
          // If it's mouseup, then we finished the dragging a range
          if (event.type === 'mouseup' || event.type === 'touchend') {
            // console.log(JSON.stringify(this.selectedRange)); // eslint-disable-line no-console
            this.guess = [];
            // Build guess!
            const sx = this.selectedRange.start.x;
            const sy = this.selectedRange.start.y;
            const ex = this.selectedRange.end.x;
            const ey = this.selectedRange.end.y;
            // 0 = up, 1 = up-right, 2 = right, 3 = down-right, 4 = down
            // 5 = down-left, 6 = left, 7 = up-left
            var direction = 0;
            if (dx === 0) {
              // Vertical
              const step = ey > sy ? 1 : -1;
              for (let i = sy; step > 0 ? i <= ey : i >= ey; i += step) {
                this.guess.push({ x: sx, y: i });
              }
              direction = step > 0 ? 4 : 0;
              if (this.guess.length == 1) {
                this.resetSelectedRange();
                return;
              }
              const newWordLine = {
                x: sx,
                y: sy,
                length: this.guess.length,
                direction,
              };
              this.lastDrag = newWordLine;
              this.showGridValueDialog();
              this.resetSelectedRange();
            } else if (dy === 0) {
              // Horizontal
              const step = ex > sx ? 1 : -1;
              for (let i = sx; step > 0 ? i <= ex : i >= ex; i += step) {
                this.guess.push({ x: i, y: sy });
              }
              direction = step > 0 ? 2 : 6;
              if (this.guess.length == 1) {
                this.resetSelectedRange();
                return;
              }
              const newWordLine = {
                x: sx,
                y: sy,
                length: this.guess.length,
                direction,
              };
              this.lastDrag = newWordLine;
              this.showGridValueDialog();
              this.resetSelectedRange();
            } else {
              this.resetSelectedRange();
            }
            // const newWordLine = {
            //     word: this.guessedWord,
            //     x: sx,
            //     y: sy,
            //     length: this.guessedWord.length,
            //     direction,
            //   };
          }
        } else if (event.type === 'mouseup' || event.type === 'touchend') {
          // Verify failed, reset range (only if at the end of a gesture)
          this.resetSelectedRange();
        } else {
          this.selectedRange.end = undefined;
        }
      } else if (event.type === 'mouseup' || event.type === 'touchend') {
        // End was "null" or had no x/y. Reset.
        this.resetSelectedRange();
      } else {
        this.selectedRange.end = undefined;
      }
      return true;
    },
    resetSelectedRange() {
      this.selectedRange = {
        start: undefined,
        end: undefined,
      };
    },
    //#endregion
  },
};
</script>

<style lang="scss" scoped>
input:disabled {
  background-color: #e3e3e3;
}
.puzzle-zone ::v-deep .wordsearch_grid {
  background: #fff;

  > div {
    > div {
      border: 1px solid #d3d3d3;
      padding: 0;

      &:not(:last-child) {
        border-right-width: 0 !important;
      }

      > div {
        > svg {
          line-height: 1 !important;
          font-weight: normal !important;
        }
      }
    }

    &:not(:last-child) {
      > div {
        border-bottom-width: 0 !important;
      }
    }
  }
}

.letter-tile {
  padding: 0 0;
  cursor: pointer;
  background-color: #f3f3f3;
  //   svg {
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //     line-height: 0;
  //     width: 100%;
  //     // fill: $body-color;
  //   }

  transition: background ease-in 0.1s;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &.letter-tile-hasText {
    background-color: #ffffff;
  }
  &.letter-tile-highlighted {
    background: rgba(255, 255, 0, 0.2);
  }
  &.letter-tile-correct {
    background: rgba(0, 255, 0, 0.3) !important;
  }
}

.word-strike {
  height: 0;
  width: 100%;
  border: 1px solid #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 100;
  box-shadow: 0 0 7px #000;
  transform-origin: 0 0;

  @for $i from 0 to 7 {
    &.word-strike-direction-#{$i} {
      transform: rotate((($i * 45deg) - 90deg));
    }
  }
  @for $i from 0 to 20 {
    &:not(.word-strike-diagonal).word-strike-length-#{$i} {
      width: ($i - 1) * 100%;
    }
    &.word-strike-diagonal.word-strike-length-#{$i} {
      width: ($i - 1) * 100% * 1.414214;
    } // 1.414214 is a hypothenuse multiplier
  }
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}
.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
.letter-input {
  width: 32px;
  height: 32px;
  border: 1px solid grey;
  padding: 4px;
  text-align: center;
  text-transform: uppercase;
}
</style>